// Shared vocabulary only. Browser observations never establish identity or access.
const USAGE_LABELS = Object.freeze({
    homepage_view: 'Homepage viewed',
    email_wallet_opened: 'Email Wallet opened',
    email_login_selected: 'Email login selected',
    email_signup_selected: 'Email registration selected',
    email_login_attempted: 'Email login submitted',
    email_signup_attempted: 'Email registration submitted',
    email_auth_succeeded: 'Email authentication succeeded',
    email_verification_pending: 'Email verification pending',
    email_verification_completed: 'Verified email observed',
    email_verification_resent: 'Verification email resent',
    email_wallet_created: 'Email wallet created',
    email_wallet_unlocked: 'Email wallet unlocked',
    email_wallet_connected: 'Email wallet connected',
    email_flow_failed: 'Email flow failed',
    wallet_login_attempted: 'Signed wallet login attempted',
    wallet_login_failed: 'Signed wallet login failed',
    wallet_login_completed: 'Signed wallet login completed',
});
const CLIENT_USAGE_TYPES = Object.freeze(Object.keys(USAGE_LABELS).filter(type => type !== 'wallet_login_completed'));
const ANALYTICS_TYPES = Object.freeze([...Object.keys(USAGE_LABELS), 'user_registered', 'space_created']);
const FAILURE_CODES = Object.freeze([
    'invalid_credentials', 'email_in_use', 'invalid_email', 'weak_password', 'rate_limited',
    'network', 'cancelled', 'validation', 'wallet_missing', 'wallet_exists', 'wallet_unlock', 'other',
]);
const FLOWS = Object.freeze(['login', 'signup', 'wallet', 'verification']);
const UUID = /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/;
function usageMeta(meta = {}, trusted = false) {
    return {
        evidence: trusted && meta.evidence === 'server_verified' ? 'server_verified' : 'client_reported',
        sessionId: /^[a-f0-9]{64}$/.test(meta.sessionId) ? meta.sessionId : '',
        attemptId: UUID.test(meta.attemptId) ? meta.attemptId : '',
        flow: FLOWS.includes(meta.flow) ? meta.flow : '',
        failureCode: FAILURE_CODES.includes(meta.failureCode) ? meta.failureCode : '',
    };
}
module.exports = { USAGE_LABELS, CLIENT_USAGE_TYPES, ANALYTICS_TYPES, FAILURE_CODES, FLOWS, UUID, usageMeta };
